import { ReactNode } from 'react'
import { cn } from 'cn'

interface UnreadIndicatorProps {
  className?: string
  iconClassName?: string
}

const UnreadIndicator = ({ className, iconClassName }: UnreadIndicatorProps): ReactNode => (
  <div className={cn('flex items-center rounded-full p-1 text-xs', className)}>
    <div className={cn('size-[5px] rounded-full bg-bg-accent-active', iconClassName)} />
  </div>
)

export default UnreadIndicator
